import * as React from "react";
import { Grid, LinearProgress } from "@material-ui/core";
import { ProductsContainer } from "src/component/shared/layout";
import { BookstoreProduct } from "../products/InitializedProducts/BookstoreProduct";
import { PublisherProduct } from "src/component/shared/layout/products/InitializedProducts/PublisherProduct";
import { AdministrationProduct } from "src/component/shared/layout/products/InitializedProducts/AdministrationProduct";
import { VejaPanelProduct } from "src/component/shared/layout/products/InitializedProducts/VejaPanelProduct";
import { PublishNewsPanelProduct } from "src/component/shared/layout/products/InitializedProducts/PublishNewsPanelProduct";
import { GeneralSalesPanelProduct } from "src/component/shared/layout/products/InitializedProducts/GeneralSalesPanelProduct";
import { BookinfoPremiumBestSellerPanelProduct } from "src/component/shared/layout/products/InitializedProducts/BookinfoPremiumBestSellerPanelProduct";
import { MarketSharesProduct } from "src/component/shared/layout/products/InitializedProducts/MarketSharesProduct";
import { MarketSharesBookstoreProduct } from "src/component/shared/layout/products/InitializedProducts/MarketSharesBookstoreProduct";
import Query from "react-apollo/Query";
import gql from "graphql-tag";
import { DistributorProduct } from "src/component/shared/layout/products/InitializedProducts/DistributorProduct";
import { ConsultingProduct } from "./InitializedProducts/ConsultingProduct";

// tslint:disable-next-line:no-empty-interface
export interface IDashBoardProps {}

// tslint:disable-next-line:no-empty-interface
export interface IDashBoardState {}

export const ACCESS_DASHBOARD = gql`
query dashBoard {
  dashBoard {
    publishers,
		bookstores,
    distributors,
    array_profiles
  }
}
`;

export class DashBoard extends React.Component<IDashBoardProps, IDashBoardState> {
  constructor(props: IDashBoardProps) {
    super(props);
  }

  public render() {
    const jsonFilter = {
      "customFilter": {
        "isChart": false,
      }
    };
      return (
        <Query query={ACCESS_DASHBOARD}
          variables={jsonFilter}>
          {({ loading, error, data, client: cliente }) => {
            const components: any[] = [];
            // TODO VERIFICAR COMO VAI FICA SE O CARA TIVER APENAS UM PRODUTO
            // let systemId = 0;

            let isAdmin = false;
            let isVeja = false;
            let isPublishNews = false;
            let isGeneralSales = false;
            let isBookinfoPremiumBestSeller = false;
            let isMarketPanel = false;
            let isMarketBookstorePanel = false;
            let isConsulting = false;
            // let hasBookstore = false;
            // let hasPublisher = false;
            if (data && data.dashBoard && data.dashBoard.array_profiles) {
                // hasBookstore = data.dashBoard.array_profiles.includes(1);
                isAdmin = data.dashBoard.array_profiles.includes(2);
                // hasPublisher = data.dashBoard.array_profiles.includes(3);
                isVeja = data.dashBoard.array_profiles.includes(4);
                isPublishNews = data.dashBoard.array_profiles.includes(5);
                isGeneralSales = data.dashBoard.array_profiles.includes(6);
                isMarketPanel = data.dashBoard.array_profiles.includes(7);
                isBookinfoPremiumBestSeller =  data.dashBoard.array_profiles.includes(8);
                isMarketBookstorePanel = data.dashBoard.array_profiles.includes(9);
                isConsulting = data.dashBoard.array_profiles.includes(10);
            }


            if (data && data.dashBoard && data.dashBoard.publishers > 0) {
              components.push(<PublisherProduct key={1} />)
              // systemId = 1
            }

            if (data && data.dashBoard && data.dashBoard.distributors > 0) {
              components.push(<DistributorProduct key={2} />)
              // systemId = 2
            }
            
            // (hasBookstore || isAdmin)
            if (data && data.dashBoard && data.dashBoard.bookstores > 0) {
              components.push(<BookstoreProduct key={3} />)
              // systemId = 3
            }

            if(isAdmin) {
                components.push(<AdministrationProduct key={4} />);
            }

            if(isVeja || isAdmin) {
                components.push(<VejaPanelProduct key={5} />)
            }

            if(isPublishNews || isAdmin) {
              components.push(<PublishNewsPanelProduct key={6} />)
            }

            if (isGeneralSales || isAdmin) {
              components.push(<GeneralSalesPanelProduct key={7} />);
            }

            if(isBookinfoPremiumBestSeller || isAdmin) {
              components.push(<BookinfoPremiumBestSellerPanelProduct key={9} />);
            }

            if(isMarketPanel || isAdmin) {
              components.push(<MarketSharesProduct key={8} />);
            }

            if(isMarketBookstorePanel || isAdmin) {
              components.push(<MarketSharesBookstoreProduct key={10} />);
            }

            if(isConsulting || isAdmin) {
              components.push(<ConsultingProduct key={11} />)
            }

            // if (components.length === 1){
            //   if (systemId === 1){
            //     window.location.href = '/publisher/sale'
            //   }else if (systemId === 2){
            //     window.location.href = '/distributor/sale'
            //   }else if (systemId === 3){
            //     window.location.href = '/bookstore/sale'
            //   }
            // }

            return <div className="wrapper">
              {loading ? <LinearProgress /> :
                <div className="wrapper">
                <Grid
                  container={true}
                  className="publisher-sale-panel panel-grid"
                  spacing={16}
                >
                  <Grid item={true} xs={12} md={12}>
                    <ProductsContainer
                      itensLine={components.length}
                      products={components}
                    />
                  </Grid>
                </Grid>
              </div>}
            </div>;
          }}
        </Query>)
  }
}



// WEBPACK FOOTER //
// ./src/component/shared/layout/products/Dashboard.tsx